<template>
    <v-app dark>
        <v-navigation-drawer
                width="250"
                class="blue-grey darken-4"
                dark
                persistent
                :mini-variant="miniVariant"
                v-model="drawer"
                stateless
                fixed
                app
                style="max-height:100vh;overflow:hidden"
        >
            <v-toolbar flat class="transparent" dense>
                <v-list  :class="{'list-border-bottom' : miniVariant}">
                    <v-list-tile>
                        <v-list-tile-action v-if="!miniVariant">
                            <pymescloudlogo style="width:50px;height:auto"></pymescloudlogo>
                        </v-list-tile-action>
                        <v-list-tile-content v-if="!miniVariant">
                            <v-list-tile-title>
                                <h3>{{appName.split('.')[0]}}<span style="opacity:0.5;font-size:0.7em">.{{appName.split('.')[1]}}</span></h3>
                            </v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            <v-btn icon @click.stop="miniVariant = !miniVariant">
                                <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
                            </v-btn>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>
            </v-toolbar>
            <v-divider></v-divider>

            <v-tooltip right :disabled="!miniVariant">
                <v-toolbar flat class="transparent" dense slot="activator">
                    <v-list class="pa-0" :class="{'list-border-bottom' : miniVariant}">
                        <v-list-tile to="/" exact>
                            <v-list-tile-action>
                                <v-icon>mdi-home</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>Resumen</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-toolbar>
                <span>Resumen</span>
            </v-tooltip>
            <v-divider></v-divider>
            <template v-for="Opcion in Menus">
                <v-list :key="Opcion.id" subheader :class="{'list-border-bottom' : miniVariant}">
                    <v-subheader>{{$t(`Menus.${Opcion.id}`)}}</v-subheader>
                    <template v-for="item in Opcion.items">
                        <v-tooltip right :disabled="!miniVariant">
                            <v-list-tile
                                    :key="item.icon"
                                    :to="`${item.link}`"
                                    exact
                                    slot="activator"
                            >
                                <v-list-tile-action>
                                    <v-icon v-html="item.icon"></v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title v-text="item.title"></v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <span v-text="item.title"></span>
                        </v-tooltip>
                        
                    </template>
                    
                   
                </v-list>
                <v-divider></v-divider>
            </template>
            <v-footer fixed>
                <cloudplan :miniVariant="miniVariant"></cloudplan>
            </v-footer>
            <!--<v-divider></v-divider>-->
        </v-navigation-drawer>

        <v-toolbar
                app
                flat
                dense
                color="primary"
                dark
        >
            <v-toolbar-side-icon
                    @click.stop="drawer = !drawer"
                    class="hidden-lg-and-up"
                    :class="searching ? 'hidden-xs-only' : ''"
            />
            <v-menu :nudge-width="100" :class="searching ? 'hidden-xs-only' : ''">
                <v-toolbar-title slot="activator" class="pl-2">
                    <span>{{ $System.currentUser.Negocio ? $System.currentUser.Negocio.nombrecomercial : 'Error'}}</span>
                    <v-icon>arrow_drop_down</v-icon>
                </v-toolbar-title>
                <v-list light>
                    <v-list-tile v-for="item in $System.currentUser.Negocios" :key="item.id" @click.native="$System.currentUser.setNegocio(item.id)">
                        <v-list-tile-title :disabled="item.id === $System.currentUser.Negocio.id" v-text="item.nombrecomercial"></v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <v-spacer></v-spacer>

            <v-btn icon @click.native.stop="searchBegin">
                <v-icon>search</v-icon>
            </v-btn>
            <div :class="{'searching--closed': !searching}" class="searching">
                <v-text-field
                        id="search"
                        v-model="search"
                        append-icon="close"
                        @click:append="searchEnd"
                        label="Search"
                        hide-details
                        single-line
                        color="white"
                        @blur="onBlur"
                ></v-text-field>
            </div>

            <v-tooltip bottom>
                <v-btn icon @click.stop="rightDrawer = !rightDrawer" slot="activator">
                    <v-badge color="red" overlap>
                        <span slot="badge">2</span>
                        <v-icon>notifications</v-icon>
                    </v-badge>
                </v-btn>
                <span>2 unread notifications</span>
            </v-tooltip>

            <v-menu :nudge-left="300" transition="slide-x-transition" :close-on-content-click="false" offset-x>
                
                <v-btn icon slot="activator">
                    <v-avatar class="white" size="32">
                        <v-icon color="primary">person</v-icon>
                    </v-avatar>
                </v-btn>
                <v-card width="300" style="border-radius:16px">
                    <v-list class="pa-0" light>
                        <v-list-tile avatar>
                            <v-list-tile-avatar>
                                <v-avatar class="primary" size="48px">
                                    <v-icon dark>mdi-account-circle</v-icon>
                                </v-avatar>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>{{$System.currentUser.Info.displayName || $System.currentUser.Info.email}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ $System.currentUser.Info.displayName ? $System.currentUser.Info.email : ''}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>

                        <v-list-tile key="profile" @click="">
                            <v-list-tile-action>
                                <v-icon>person</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>My Profile</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>

                        <v-list-tile :loading="loading" key="lock_open" @click.native="logout">
                            <v-list-tile-action>
                                <v-icon>lock_open</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>Logout</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-card>
            </v-menu>
        </v-toolbar>

        <v-content>
            <router-view/>
        </v-content>

        <v-navigation-drawer
                temporary
                :right="right"
                v-model="rightDrawer"
                fixed
                app
        >
            <v-toolbar flat prominent dark class="primary">
                <v-toolbar-title>Notifications</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.stop="rightDrawer = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-list subheader dense>
                <v-subheader>All notifications</v-subheader>
                <v-list-tile @click="">
                    <v-list-tile-action>
                        <v-icon>person_add</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title>
                        12 new users registered
                    </v-list-tile-title>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile @click="">
                    <v-list-tile-action>
                        <v-icon>data_usage</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title>
                        DB overloaded 80%
                    </v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
    </v-app>
</template>

<script>
const {db} = require('@/plugins/firebase')
    export default {
        name: 'miPyMEScloud',
        components: {
            pymescloudlogo: () => import('@/components/svg/pymescloud'),
            cloudplan: () => import('@/components/widgets/cloudplan')
        },
        data() {
            return {
                appName: 'PyMEs.cloud',
                drawer: true,
                fixed: false,
                loading: false,
                Menus: [],
                miniVariant: false,
                right: true,
                rightDrawer: false,
                tabs: null,
                tabsItems: [
                    {
                        id: 1,
                        title: 'Indicators',
                        link: 'indicators'
                    },
                    {
                        id: 2,
                        title: 'Backup',
                        link: 'backup'
                    },
                    {
                        id: 3,
                        title: 'Logs',
                        link: 'logs'
                    }
                ],
                searching: false,
                search: ''
            }
        },
        mounted() {
            db.ref('/System/Menus').once('value').then(snap => {
                snap.forEach(s => {
                    let o = s.val()
                    o['id'] = s.key
                    this.Menus.push(o)
                })
            })
        },
        methods: {
            logout() {
                this.loading = true
                this.$auth.signOut().then(ok => {
                    this.loading = false
                })
            },
            onBlur() {
                this.searching = false
                this.search = ''
            },

            searchBegin() {
                this.searching = true
                setTimeout(() => document.querySelector('#search').focus(), 50)
            },

            searchEnd() {
                this.searching = false
                this.search = ''
                document.querySelector('#search').blur()
            }
        }
    }
</script>

<style scoped lang="stylus">
    @import '../../../node_modules/vuetify/src/stylus/settings/_variables.styl';

    .bottom-menu {
        position: absolute;
        width: 100%;
        bottom: 0;
    }

    .searching {
        overflow: hidden;
        width: 208px;
        padding-left: 8px;
        transition: $primary-transition;
    }

    .searching--closed {
        padding-left: 0;
        width: 0;
    }

    .searching > * {
        right: 8px;
    }

    .searching--closed > * {
        display: none;
    }

    .hidden-searching {
        @media $display-breakpoints.sm-and-down {
            display: none !important;
        }
    }

    .list-border-bottom {
        border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    }
</style>
